import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "subheader col-6" }
const _hoisted_4 = { class: "subheader-title" }
const _hoisted_5 = {
  key: 0,
  class: "badge badge-primary fw-500"
}
const _hoisted_6 = {
  key: 1,
  class: "badge badge-warning fw-500"
}
const _hoisted_7 = {
  key: 2,
  class: "badge badge-danger fw-500"
}
const _hoisted_8 = {
  key: 3,
  class: "badge badge-info fw-500"
}
const _hoisted_9 = {
  key: 4,
  class: "badge badge-success fw-500"
}
const _hoisted_10 = { class: "subheader-block ml-auto demo" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "btn-group" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_20 = { class: "d-flex flex-start w-100" }
const _hoisted_21 = { class: "d-flex flex-fill" }
const _hoisted_22 = { class: "flex-fill" }
const _hoisted_23 = { class: "m-0" }
const _hoisted_24 = {
  key: 1,
  class: "alert alert-primary"
}
const _hoisted_25 = { class: "d-flex flex-start w-100" }
const _hoisted_26 = { class: "d-flex flex-fill" }
const _hoisted_27 = { class: "flex-fill" }
const _hoisted_28 = { class: "m-0" }
const _hoisted_29 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-xl-12" }
const _hoisted_32 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_33 = {
  class: "panel-container show",
  id: "panel-editers"
}
const _hoisted_34 = { class: "panel-content contents" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-5 contCnt input-daterange input-group" }
const _hoisted_37 = { class: "col-md-5 contCnt disableWhite" }
const _hoisted_38 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-3 contCnt disableWhite" }
const _hoisted_41 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_42 = { class: "col-md-2 contCnt" }
const _hoisted_43 = { class: "col-md-5 contCnt disableWhite" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-md-5 contCnt disableWhite" }
const _hoisted_46 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_47 = { class: "col-md-5 contCnt disableWhite" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-5 contCnt" }
const _hoisted_51 = { class: "badge ml-2" }
const _hoisted_52 = {
  key: 0,
  class: "isMissMatch"
}
const _hoisted_53 = { class: "col-md-5 contCnt disableWhite" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-xl-12" }
const _hoisted_57 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_58 = {
  class: "panel-container show",
  id: "panel-editers4det"
}
const _hoisted_59 = { class: "panel-content contents" }
const _hoisted_60 = { class: "text-success fw-500" }
const _hoisted_61 = { class: "modal-footer" }
const _hoisted_62 = { class: "modal-footer" }
const _hoisted_63 = { class: "custom-control custom-checkbox" }
const _hoisted_64 = {
  class: "custom-control custom-radio custom-control-inline",
  style: {"padding-top":"10px","margin-left":"20px"}
}
const _hoisted_65 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_66 = {
  class: "custom-control custom-radio custom-control-inline",
  style: {"padding-top":"10px","margin-left":"20px"}
}
const _hoisted_67 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_68 = {
  class: "custom-control custom-checkbox",
  style: {"padding-top":"10px"}
}
const _hoisted_69 = ["disabled"]
const _hoisted_70 = ["textContent"]
const _hoisted_71 = {
  class: "custom-control custom-checkbox",
  style: {"padding-top":"10px"}
}
const _hoisted_72 = ["disabled"]
const _hoisted_73 = ["textContent"]
const _hoisted_74 = {
  id: "body4Rakuraku",
  class: "panel-container"
}
const _hoisted_75 = { class: "gtablecell" }
const _hoisted_76 = {
  id: "footer4Recept",
  class: "modal-footer"
}
const _hoisted_77 = ["disabled"]
const _hoisted_78 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_VTooltip = _resolveComponent("VTooltip")!
  const _component_Or_tableClaim = _resolveComponent("Or_tableClaim")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!
  const _component_Mo_modal_n = _resolveComponent("Mo_modal_n")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_Mo_modal_right_l = _resolveComponent("Mo_modal_right_l")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          _cache[38] || (_cache[38] = _createTextVNode(" 請求書作成 ")),
          (_ctx.delegate.c_claim_status == 0)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_5, " 請求データ登録済"))
            : _createCommentVNode("", true),
          (_ctx.delegate.c_claim_status == 1)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_6, " 承認待ち"))
            : _createCommentVNode("", true),
          (_ctx.delegate.c_claim_status == 3)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_7, "差し戻し"))
            : _createCommentVNode("", true),
          (_ctx.delegate.c_claim_status == 10)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_8, "承認済・出力待ち"))
            : _createCommentVNode("", true),
          (_ctx.delegate.c_claim_status == 20)
            ? (_openBlock(), _createElementBlock("sup", _hoisted_9, "請求書作成済"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.btnShow4Rewrite)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-info waves-effect waves-themed",
              disabled: _ctx.btnDisable || _ctx.btnDisable4Rewrite,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reriteConf()))
            }, _cache[39] || (_cache[39] = [
              _createElementVNode("span", { class: "fal fa-undo-alt mr-1" }, null, -1),
              _createTextVNode("再編集 ")
            ]), 8, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.btnShow4conf)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-primary waves-effect waves-themed",
              disabled: _ctx.btnDisable || _ctx.btnDisable4conf,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upd(false, true, false)))
            }, _cache[40] || (_cache[40] = [
              _createElementVNode("span", { class: "fal fa-envelope mr-1" }, null, -1),
              _createTextVNode("承認依頼 ")
            ]), 8, _hoisted_12))
          : _createCommentVNode("", true),
        (_ctx.btnShow4save)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn-primary waves-effect waves-themed",
              disabled: _ctx.btnDisable || _ctx.btnDisable4save,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.upd(false, false, false)))
            }, _cache[41] || (_cache[41] = [
              _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
              _createTextVNode("登録 ")
            ]), 8, _hoisted_13))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.btnShow4create)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["btn btn-primary waves-effect waves-themed", { isMissMatchBtn: _ctx.isMissMatchPrice }]),
                disabled: _ctx.btnDisable || _ctx.btnDisable4create,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalInvoice()))
              }, _cache[42] || (_cache[42] = [
                _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
                _createTextVNode("作成 ")
              ]), 10, _hoisted_15))
            : _createCommentVNode("", true)
        ]),
        (_ctx.btnShow4create)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: _normalizeClass(["btn btn-secondary waves-effect waves-themed", { isMissMatchBtn: _ctx.isMissMatchPrice }]),
              disabled: _ctx.btnDisable || _ctx.btnDisable4create,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModalRakurakuhistory()))
            }, " 楽楽明細履歴 ", 10, _hoisted_16))
          : _createCommentVNode("", true),
        (_ctx.btnShow4delete)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "button",
              class: "btn btn-danger waves-effect waves-themed",
              disabled: _ctx.btnDisable || _ctx.btnDisable4delete,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.delConf()))
            }, _cache[43] || (_cache[43] = [
              _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
              _createTextVNode("削除 ")
            ]), 8, _hoisted_17))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/invoiceSearch')))
        }, _cache[44] || (_cache[44] = [
          _createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1),
          _createTextVNode("戻る ")
        ]), 8, _hoisted_18)
      ])
    ]),
    (_ctx.fmShowConf)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
              _createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
                _createElementVNode("i", { class: "fal fa-info-circle" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[48] || (_cache[48] = _createElementVNode("span", { class: "h5" }, "あなたが承認者です", -1)),
                _cache[49] || (_cache[49] = _createElementVNode("p", null, " この請求書はあなたが承認者です。以下のボタンから承認か、差戻を選択できます。 ", -1)),
                _createElementVNode("p", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info waves-effect waves-themed",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.upd4Approval(true)))
                  }, _cache[45] || (_cache[45] = [
                    _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
                    _createTextVNode("承認 ")
                  ])),
                  _cache[47] || (_cache[47] = _createElementVNode("span", { style: {"width":"20px"} }, " 　", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger waves-effect waves-themed",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.upd4Approval(false)))
                  }, _cache[46] || (_cache[46] = [
                    _createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1),
                    _createTextVNode("差戻 ")
                  ]))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fmShowConf4self)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
              _createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
                _createElementVNode("i", { class: "fal fa-info-circle" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[53] || (_cache[53] = _createElementVNode("span", { class: "h5" }, "請求書を出力するには、ご自身での承認が必要です", -1)),
                _cache[54] || (_cache[54] = _createElementVNode("p", null, " 請求書を作り終わりましたら、以下の承認ボタンを押して、ご自身での承認をお願い致します。承認する事でExcel出力ができるようになります。 ", -1)),
                _createElementVNode("p", _hoisted_28, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info waves-effect waves-themed",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.upd4Approval(true)))
                  }, _cache[51] || (_cache[51] = [
                    _createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1),
                    _createTextVNode("承認 ")
                  ])),
                  _cache[52] || (_cache[52] = _createElementVNode("span", { style: {"width":"20px"} }, " 　", -1))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fmShowConfEx)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[56] || (_cache[56] = [
          _createStaticVNode("<div class=\"d-flex flex-start w-100\" data-v-fa344ee8><div class=\"mr-2 hidden-md-down\" data-v-fa344ee8><span class=\"icon-stack icon-stack-lg\" data-v-fa344ee8><i class=\"fal fa-info-circle\" data-v-fa344ee8></i></span></div><div class=\"d-flex flex-fill\" data-v-fa344ee8><div class=\"flex-fill\" data-v-fa344ee8><span class=\"h5\" data-v-fa344ee8>この請求書は承認依頼中です</span><p data-v-fa344ee8> この請求書は承認依頼中の為、変更ができません。お急ぎの場合は、承認者にご連絡ください。 </p></div></div></div>", 1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _cache[69] || (_cache[69] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "基本情報"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_33, [
            _cache[68] || (_cache[68] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _cache[57] || (_cache[57] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "請求No", -1)),
                _createElementVNode("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtClaimNo",
                    class: "form-control form-control-sm claimNo",
                    disabled: "",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.delegate.c_claim_number) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_claim_number]
                  ])
                ]),
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "請求日", -1)),
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_Mt_dtp, {
                    contdate: _ctx.claimDate,
                    "onUpdate:contdate": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.claimDate) = $event)),
                    holidays: _ctx.delegate4list,
                    "onUpdate:holidays": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.delegate4list) = $event)),
                    disabled: true,
                    class: "notClear"
                  }, null, 8, ["contdate", "holidays"]),
                  (_ctx.errors?.path === 'claimDate')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "請求先", -1)),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_vSelect, {
                    disabled: _ctx.inputDisable4conf,
                    options: _ctx.delegate4list.items4Client,
                    modelValue: _ctx.delegate.c_client_id,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.delegate.c_client_id) = $event)),
                    label: "c_client_name",
                    reduce: (label) => label.c_client_id
                  }, null, 8, ["disabled", "options", "modelValue", "reduce"]),
                  (_ctx.errors?.path === 'c_client_id')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtClaimNo",
                    class: "form-control form-control-sm claimNo",
                    disabled: "",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.paySite) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.paySite]
                  ])
                ]),
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "担当者", -1)),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_vSelect, {
                    disabled: _ctx.inputDisable4conf,
                    options: _ctx.getOpStaffs(),
                    modelValue: _ctx.delegate.c_staff_id,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.delegate.c_staff_id) = $event)),
                    label: "c_staff_name",
                    reduce: (label) => label.c_staff_id
                  }, null, 8, ["disabled", "options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "入金予定日", -1)),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_Mt_dtp, {
                    contdate: _ctx.payLimit,
                    "onUpdate:contdate": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.payLimit) = $event)),
                    holidays: _ctx.delegate4list,
                    "onUpdate:holidays": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.delegate4list) = $event)),
                    disabled: _ctx.inputDisable4conf,
                    class: "notClear"
                  }, null, 8, ["contdate", "holidays", "disabled"]),
                  (_ctx.errors?.path === 'payLimit')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "備考", -1)),
                _createElementVNode("div", _hoisted_47, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtBiko",
                    class: "form-control form-control-sm",
                    disabled: _ctx.inputDisable4conf,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.delegate.c_claim_remarks) = $event))
                  }, null, 8, _hoisted_48), [
                    [_vModelText, _ctx.delegate.c_claim_remarks]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _cache[66] || (_cache[66] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "対象案件番号", -1)),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-primary waves-effect waves-themed",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.goProject($event)))
                  }, [
                    _cache[63] || (_cache[63] = _createTextVNode(" 対象案件に移動 ")),
                    _createElementVNode("span", _hoisted_51, " 案件番号：" + _toDisplayString(_ctx.delegate.project.c_project_number), 1)
                  ]),
                  (_ctx.isMissMatchPrice)
                    ? (_openBlock(), _createBlock(_component_VTooltip, {
                        key: 0,
                        class: "isMissMatchIcon"
                      }, {
                        popper: _withCtx(() => [
                          _createTextVNode(" 請求書の小計:" + _toDisplayString(_ctx.delegate.c_claim_subtotal!.toLocaleString("ja-JP")), 1),
                          _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" 紐付く売上明細の合計:" + _toDisplayString(_ctx.delegate.sumSales!.toLocaleString("ja-JP")), 1)
                        ]),
                        default: _withCtx(() => [
                          (_ctx.isMissMatchPrice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, _cache[64] || (_cache[64] = [
                                _createElementVNode("i", { class: "fal fa-info-circle" }, null, -1),
                                _createTextVNode(" 売上明細の合計値と、請求書の合計値が一致していません ")
                              ])))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _cache[67] || (_cache[67] = _createElementVNode("div", { class: "col-md-1 contTitle" }, "件名", -1)),
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtBiko",
                    class: "form-control form-control-sm",
                    disabled: _ctx.inputDisable4conf,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.delegate.c_claim_title_1) = $event))
                  }, null, 8, _hoisted_54), [
                    [_vModelText, _ctx.delegate.c_claim_title_1]
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _cache[71] || (_cache[71] = _createElementVNode("div", { class: "panel-hdr" }, [
            _createElementVNode("h2", null, "請求内容"),
            _createElementVNode("div", { class: "panel-toolbar" }, [
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-collapse",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Collapse"
              }),
              _createElementVNode("button", {
                class: "btn btn-panel",
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_58, [
            _cache[70] || (_cache[70] = _createElementVNode("div", { class: "loader" }, [
              _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
            ], -1)),
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_component_Or_tableClaim, {
                ref: "Or_tableClaim",
                items: _ctx.delegate.details,
                "onUpdate:items": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.delegate.details) = $event))
              }, null, 8, ["items"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[22] || (_cache[22] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _cache[72] || (_cache[72] = _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)),
        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => _cache[73] || (_cache[73] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => _cache[74] || (_cache[74] = [
        _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("br")
        ], -1)
      ])),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_rewiteConf" }, {
      title: _withCtx(() => [
        _cache[75] || (_cache[75] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalRewriteConf), 1)
      ]),
      body: _withCtx(() => _cache[76] || (_cache[76] = [
        _createTextVNode(" 未承認の状態に戻りますと、再度、承認を経なければ請求書を出力する事ができません。 ")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("button", {
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.rewrite())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeModal4RewriteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _cache[77] || (_cache[77] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => _cache[78] || (_cache[78] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("button", {
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_n, { ref: "Mo_modal_invoiceCreate" }, {
      title: _withCtx(() => _cache[79] || (_cache[79] = [
        _createTextVNode("請求書作成")
      ])),
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_63, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "ckExcelDL",
              class: "custom-control-input",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.invoiceCreateInfo.isExcelDownload) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.invoiceCreateInfo.isExcelDownload]
            ]),
            _cache[80] || (_cache[80] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "ckExcelDL"
            }, "Excelファイルをダウンロード", -1))
          ]),
          _createElementVNode("div", _hoisted_64, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "custom-control-input",
              id: "radioMarkY",
              name: "radioMark",
              value: "1",
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.invoiceCreateInfo.isCompanySealOutput) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.invoiceCreateInfo.isCompanySealOutput]
            ]),
            _cache[81] || (_cache[81] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "radioMarkY"
            }, "社印あり", -1))
          ]),
          _createElementVNode("div", _hoisted_65, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "custom-control-input",
              id: "radioMarkN",
              name: "radioMark",
              value: "2",
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.invoiceCreateInfo.isCompanySealOutput) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.invoiceCreateInfo.isCompanySealOutput]
            ]),
            _cache[82] || (_cache[82] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "radioMarkN"
            }, "社印なし", -1))
          ]),
          _cache[89] || (_cache[89] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", _hoisted_66, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "custom-control-input",
              id: "radioFormatY",
              name: "radioFormat",
              value: "1",
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.invoiceCreateInfo.outputFormat) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.invoiceCreateInfo.outputFormat]
            ]),
            _cache[83] || (_cache[83] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "radioFormatY"
            }, "新形式　", -1))
          ]),
          _createElementVNode("div", _hoisted_67, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "custom-control-input",
              id: "radioFormatN",
              name: "radioFormat",
              value: "0",
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.invoiceCreateInfo.outputFormat) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.invoiceCreateInfo.outputFormat]
            ]),
            _cache[84] || (_cache[84] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "radioFormatN"
            }, "旧形式", -1))
          ]),
          _createElementVNode("div", _hoisted_68, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "ckPdfDL",
              class: "custom-control-input",
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.invoiceCreateInfo.isPDFDownload) = $event)),
              disabled: _ctx.isNotPdfDownload
            }, null, 8, _hoisted_69), [
              [_vModelCheckbox, _ctx.invoiceCreateInfo.isPDFDownload]
            ]),
            _cache[85] || (_cache[85] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "ckPdfDL"
            }, "PDFファイルをダウンロード", -1)),
            _cache[86] || (_cache[86] = _createTextVNode("   ")),
            _createElementVNode("span", {
              style: {"color":"red","font-weight":"bold"},
              textContent: _toDisplayString(_ctx.pdfDownloadErr)
            }, null, 8, _hoisted_70)
          ]),
          _createElementVNode("div", _hoisted_71, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "ckRakuRakuUp",
              class: "custom-control-input",
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.invoiceCreateInfo.isRakurakuUpload) = $event)),
              disabled: _ctx.isNotRakurakuSync
            }, null, 8, _hoisted_72), [
              [_vModelCheckbox, _ctx.invoiceCreateInfo.isRakurakuUpload]
            ]),
            _cache[87] || (_cache[87] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "ckRakuRakuUp"
            }, "楽楽明細に連携", -1)),
            _cache[88] || (_cache[88] = _createTextVNode("   ")),
            _createElementVNode("span", {
              style: {"color":"red","font-weight":"bold"},
              textContent: _toDisplayString(_ctx.rakurakuSyncErr)
            }, null, 8, _hoisted_73)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal",
          onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.execModalInvoice()))
        }, " OK "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          "data-dismiss": "modal",
          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.closeModalInvoice()))
        }, " キャンセル ")
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_right_l, { ref: "Mo_modal_rakuraku" }, {
      title: _withCtx(() => _cache[90] || (_cache[90] = [
        _createElementVNode("div", { id: "header4Recept" }, "楽楽明細連携履歴", -1)
      ])),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          _cache[91] || (_cache[91] = _createElementVNode("div", { class: "loader" }, [
            _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
          ], -1)),
          _createVNode(_component_vue_good_table, {
            mode: "remote",
            onPageChange: _ctx.onPageChange,
            onSortChange: _ctx.onSortChange,
            columns: _ctx.columns,
            rows: _ctx.rakurakuhistory,
            "sort-options": {
              enabled: false,
            },
            "pagination-options": {
              enabled: false,
            },
            totalRows: _ctx.delegate.pager.maxcount
          }, {
            "table-row": _withCtx((props) => [
              _createElementVNode("div", _hoisted_75, _toDisplayString(props.formattedRow[props.column.field]), 1)
            ]),
            _: 1
          }, 8, ["onPageChange", "onSortChange", "columns", "rows", "totalRows"])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("button", {
            disabled: _ctx.btnDisable,
            type: "button",
            class: "btn btn-secondary waves-effect waves-themed",
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.closeModalRakurakuhistory()))
          }, _cache[92] || (_cache[92] = [
            _createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1),
            _createTextVNode("閉じる ")
          ]), 8, _hoisted_77)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _cache[93] || (_cache[93] = _createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => _cache[94] || (_cache[94] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("button", {
            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}